import { render, staticRenderFns } from "./DetailedSupplyTable.vue?vue&type=template&id=cff2f840&scoped=true"
import script from "./DetailedSupplyTable.vue?vue&type=script&lang=js"
export * from "./DetailedSupplyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff2f840",
  null
  
)

export default component.exports